// Truva theme control — System / Light / Dark.
//
// Persisted value (localStorage 'truva__theme'):
//   "system" -> depends on OS prefers-color-scheme (no data-theme attribute)
//   "light"  -> forces :root[data-theme="light"]
//   "dark"   -> forces :root[data-theme="dark"] (beats the light media query)
//
// The <html> data-theme attribute is read by tokens.css override blocks. A
// pre-paint bootstrap in public/index.html applies the persisted value before
// first render to avoid a flash of the wrong theme; this module is the in-app
// API used by the Settings control.

export const THEME_STORAGE_KEY = 'truva__theme';

export function applyTheme(mode) {
  const el = document.documentElement;
  const norm = mode === 'light' ? 'light' : mode === 'dark' ? 'dark' : 'system';
  if (norm === 'system') {
    el.removeAttribute('data-theme');
  } else {
    el.setAttribute('data-theme', norm);
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, norm);
  } catch (_) {
    /* storage unavailable (private mode etc.) — in-memory only */
  }
  return norm;
}

// Capacitor (iOS/Android) shells follow the phone's appearance by default;
// the website defaults to light. An explicit choice in Settings wins on both.
export function isNativeApp() {
  try {
    const cap = window.Capacitor;
    if (cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()) return true;
    return window.location.protocol === 'capacitor:';
  } catch (_) {
    return false;
  }
}

export function defaultTheme() {
  return isNativeApp() ? 'system' : 'light';
}

export function getTheme() {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch (_) {}
  return defaultTheme();
}

export function initTheme() {
  // Re-sync the attribute from storage (idempotent with the index.html
  // bootstrap). Deliberately does NOT persist: a stored value means the user
  // chose it, and the plain default must stay free to change.
  const mode = getTheme();
  const el = document.documentElement;
  if (mode === 'system') el.removeAttribute('data-theme');
  else el.setAttribute('data-theme', mode);
  return mode;
}